import ReactDOM from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import './assets/css/bootstrap.min.css';
import './assets/css/bootstrap-print.css';
import './assets/css/base.css';
import './assets/css/rcstyle.scss';
import './assets/css/style1page.css';
import './assets/css/blockSNSEdit.css';
import './assets/css/animation.css';
import { UserProvider } from './contexts/UserContext';
import HTMLExportContextProvider from './contexts/HtmlExportContext';

import ImagesProvider from './contexts/ImagesContext';
import PagesProvider from './contexts/PagesContext';
import CategoriesProvider from './contexts/CategoriesContext';
import PlansProvider from './contexts/PlanContext';
import FilesProvider from './contexts/FileContext';
import { TemplatesProvider } from './contexts/TemplatesContext';
import { LayoutProvider } from './contexts/LayoutContext';
import { PageTemplatesProvider } from './contexts/PageTemplatesContext';
import PageTemplateCategoriesProvider from './contexts/PageTemplateCategoriesContext';
import { SelectedElementProvider } from './contexts/SelectedElementContext';
import config from './config';
import { PublishProvider } from './contexts/PublishContext';
import VideosProvider from './contexts/VideoContext';
import ToastProvider from './contexts/ToastContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

const emotionCache = createCache({
  key: 'css',
  container: document.head,
  prepend: true,
  speedy: false,
});

const { googleApiKey } = config;

root.render(
  <CacheProvider value={emotionCache}>
    <HTMLExportContextProvider>
      <GoogleOAuthProvider clientId={googleApiKey}>
        <LayoutProvider>
          <ToastProvider>
            <PlansProvider>
              <PagesProvider>
                <FilesProvider>
                  <VideosProvider>
                    <CategoriesProvider>
                      <TemplatesProvider>
                        <PageTemplateCategoriesProvider>
                          <PageTemplatesProvider>
                            <ImagesProvider>
                              <SelectedElementProvider>
                                <UserProvider>
                                  <PublishProvider>
                                    <HelmetProvider>
                                      <Helmet titleTemplate="%s | ビルドセルフ  - BUILD-SELF" defaultTitle="ビルドセルフ - BUILD-SELF" />
                                      <App />
                                    </HelmetProvider>
                                  </PublishProvider>
                                </UserProvider>
                              </SelectedElementProvider>
                            </ImagesProvider>
                          </PageTemplatesProvider>
                        </PageTemplateCategoriesProvider>
                      </TemplatesProvider>
                    </CategoriesProvider>
                  </VideosProvider>
                </FilesProvider>
              </PagesProvider>
            </PlansProvider>
          </ToastProvider>
        </LayoutProvider>
      </GoogleOAuthProvider>
    </HTMLExportContextProvider>
  </CacheProvider>,
);
